/**
 * Downloads a file from the given URL with a specified filename
 * @param url - The URL of the file to download (e.g., presigned S3 URL)
 * @param filename - The name to save the file as
 * @throws Error if the download fails
 */
export const downloadFile = async (url: string, filename: string): Promise<void> => {
    try {
        // Fetch the file as a blob
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
        }

        const blob = await response.blob();

        // Create a temporary object URL
        const objectUrl = URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger download
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = filename;

        // Append to body, click, and remove
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();

        // Clean up the object URL after a short delay
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch (error) {
        console.error('Download error:', error);
        throw error;
    }
};
